import Image from "../../components/general/Image";
import HeroSectionImage from "../../assets/about/HeroSection.png";
import AMD from "../../assets/about/AMD.png";
import Walmart from "../../assets/about/Walmart.png";
import ebay from "../../assets/about/ebay.png";
import Visa from "../../assets/about/Visa.png";
import Honda from "../../assets/about/Honda.png";
import Asus from "../../assets/about/Asus.png";
import CodingBackground from "../../assets/common/CodingBackground.png";
import React from "react";
const upperContent = [
    {
        image: AMD,
        text: 'One of the largest providers to processor services to UK SMEs'
    },
    {
        image: Honda,
        text: 'A fintech startup backed by AngelList and Anthemis Group'
    },
    {
        image: ebay,
        text: 'A fintech ecommerce backed by AngelList and Anthemis Group'
    },
]

const lowerContent = [
    {
        image: Visa,
        text: 'One of the largest providers to banking services to USA SMEs'
    },
    {
        image: Asus,
        text: 'One of the largest providers to IT services to UK SMEs'
    },
    {
        image: Walmart,
        text: 'One of the largest providers to processor services to UK SMEs'
    },

]

const WhyUs = () => {
    const backgroundStyles = {
        backgroundImage: `url(${CodingBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'initial',
        backgroundRepeat: 'no-repeat'
    }
    return (
        <section className="!py-[50px]" style={backgroundStyles}>
            <div className="--layout-padding max-width">
                <div className="md:flex md:items-center lg:justify-center lg:gap-[50px]">
                    <div className="lg:w-[50%]">
                        <p className="text-[18px] lg:text-[22px]"> Why Devhire </p>
                        <h1 className="font-semibold text-[30px] lg:text-55"> Wherever your roadmap goes next, we’ve got the team to take you there</h1>
                    </div>
                    <Image src={HeroSectionImage} className='w-full lg:w-[40%] my-[20px] md:mt-0' alt="HeroSection" />
                </div>

                <div className="bg-[#292929] rounded-[10px] p-[20px] lg:py-[50px] lg:px-[50px] lg:translate-y-[100px] flex flex-col gap-[20px] md:grid md:grid-cols-2 lg:grid-cols-6 lg:gap-x-[20px] md:gap-y-[40px]">
                    {/* Upper row: items in 1, 3, 5 */}
                    <div>
                        <Image className="w-full h-[40px] !object-contain" src={upperContent[0].image} alt="HeroSection" />
                        <p className="text-[#EFF1F6] text-extra-light text-[14px] mt-[15px] text-center">{upperContent[0].text}</p>
                    </div>
                    <div className="hidden lg:block" /> {/* empty col 2 */}
                    <div>
                        <Image className="w-full h-[40px] !object-contain" src={upperContent[1].image} alt="HeroSection" />
                        <p className="text-[#EFF1F6] text-extra-light text-[14px] mt-[15px] text-center">{upperContent[1].text}</p>
                    </div>
                    <div className="hidden lg:block" /> {/* empty col 4 */}
                    <div>
                        <Image className="w-full h-[40px] !object-contain" src={upperContent[2].image} alt="HeroSection" />
                        <p className="text-[#EFF1F6] text-extra-light text-[14px] mt-[15px] text-center">{upperContent[2].text}</p>
                    </div>
                    <div className="hidden lg:block" /> {/* empty col 6 */}

                    {/* Lower row: items in 2, 4, 6 */}
                    <div className="hidden lg:block" /> {/* empty col 1 */}
                    <div>
                        <Image className="w-full h-[40px] !object-contain" src={lowerContent[0].image} alt="HeroSection" />
                        <p className="text-[#EFF1F6] text-extra-light text-[14px] mt-[15px] text-center">{lowerContent[0].text}</p>
                    </div>
                    <div className="hidden lg:block" /> {/* empty col 3 */}
                    <div>
                        <Image className="w-full h-[40px] !object-contain" src={lowerContent[1].image} alt="HeroSection" />
                        <p className="text-[#EFF1F6] text-extra-light text-[14px] mt-[15px] text-center">{lowerContent[1].text}</p>
                    </div>
                    <div className="hidden lg:block" /> {/* empty col 5 */}
                    <div>
                        <Image className="w-full h-[40px] !object-contain" src={lowerContent[2].image} alt="HeroSection" />
                        <p className="text-[#EFF1F6] text-extra-light text-[14px] mt-[15px] text-center">{lowerContent[2].text}</p>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default WhyUs;